import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import * as fromApp from '../../store/app.reducers';
import * as fromCompare from '../store/compare.reducers';
import * as fromProfile from '../../profile/store/profile.reducers';
import * as CompareActions from '../store/compare.actions';
import {Profile} from '../../profile/profile.model';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-compare-generate',
    templateUrl: './compare-generate.component.html',
    styleUrls: ['./compare-generate.component.scss'],
    standalone: false
})
export class CompareGenerateComponent implements OnInit {

  compareState: Observable<fromCompare.State>;
  profileState: Observable<fromProfile.State>;

  compareCount: number[] = [0, 1];
  compareProfile: Profile[] = [];

  constructor(
    public notifierService: ToastrService,
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.compareState = this.store.select('compare');
    this.profileState = this.store.select('profile');
    this.store.dispatch(
      new CompareActions.ResetAudits()
    );
  }

  onGetCompareData() {
    if (this.compareCount.length === this.compareProfile.length) {
      this.store.dispatch(
        new CompareActions.GetCompareData({params: []})
      );
    } else {
      this.notifierService.warning('Select all profiles you want to compare');
    }
  }

  onSelectProfile($event, $idx) {
    $event['idx'] = $idx;
    let storedIdx: any = -1;
    for (const i in this.compareProfile) {
      if (this.compareProfile[i].idx === $idx) {
        storedIdx = i;
        break;
      }
    }
    if (storedIdx < 0) {
      this.compareProfile.push($event);
    } else {
      this.compareProfile[storedIdx] = $event;
    }
    this.store.dispatch(
      new CompareActions.AddAudit($event)
    );
  }

  increaseCompareCount() {
    if (this.compareCount.length >= 5) {
      this.notifierService.warning('You can compare maximum of 5 reports');
    } else {
      this.compareCount.push(this.compareCount.length);
    }
  }

}
